import gql from 'graphql-tag'
import { accommodationFragment } from '@/graphql/accommodation/accommodationFragments'

export const ACCOMMODATIONS = gql`
    query accommodations(
        $ids: [ID]
        $page: Int
        $first: Int
        $trashed: Trashed
    ) {
        accommodations(
            ids: $ids
            page: $page
            first: $first
            trashed: $trashed
        ){
            data{
                ...accommodationFragment
            }
        }
    }
    ${accommodationFragment}
`
export const ACCOMMODATIONSSEARCH = gql`
    query accommodationsSearch(
        $searchText: String
        $page: Int
        $first: Int
        $trashed: Trashed
    ) {
        accommodationsSearch(
            searchText: $searchText
            page: $page
            first: $first
            trashed: $trashed
        ){
            data{
                ...accommodationFragment
            }
        }
    }
    ${accommodationFragment}
`